import { useEffect, useState } from "react";
import { Instagram, Music2, Youtube } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const PLATFORMS = [
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "tiktok", label: "TikTok", Icon: Music2 },
  { key: "youtube", label: "YouTube", Icon: Youtube },
];

export default function SocialLinks({ light = false }) {
  const [socials, setSocials] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/settings/socials`)
      .then((r) => (r.ok ? r.json() : null))
      .then(setSocials)
      .catch(() => {});
  }, []);

  if (!socials) return null;
  const active = PLATFORMS.filter((p) => socials[p.key]);
  if (!active.length) return null;

  return (
    <div data-testid="social-links" className="flex gap-3">
      {active.map(({ key, label, Icon }) => (
        <a
          key={key}
          href={socials[key]}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`social-link-${key}`}
          aria-label={`Triple O on ${label}`}
          className={`flex h-10 w-10 items-center justify-center border transition-colors duration-300 ${
            light
              ? "border-ink/20 text-ink/70 hover:border-ink hover:bg-ink hover:text-acid"
              : "border-white/15 text-paper/70 hover:border-acid hover:bg-acid hover:text-ink"
          }`}
        >
          <Icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
}
